var _defs, _ellipse, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1174({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.5px;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.73,
    cy: 6.76,
    rx: 5.73,
    ry: 5.64
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.79,
    y1: 10.74,
    x2: 15,
    y2: 14.88
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.73,
    y1: 3.58,
    x2: 6.73,
    y2: 9.74
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.82,
    y1: 6.66,
    x2: 3.65,
    y2: 6.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1174);
export default __webpack_public_path__ + "static/media/Symbolpack_1_174.74b7f0d4eeeb03528acc0ee336622b8a.svg";
export { ForwardRef as ReactComponent };